import * as React from "react";
import { connect } from "react-redux";
import { DispatchFunc } from "../../../../../store/ActionTypes";
import { remoteTrigger } from "../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { AccountRequest } from "../../../../../store/Accounts/Types";
import { GeneralLedgers } from "../../../../../store/GeneralLedgers/Types";
import { isRemoteLoading, ReduxState } from "../../../../../store/ReduxState";
import { Pagination } from "@vwpfs/mary-air-lib/components/air/06-molecules/Pagination";
import { RowData, Table } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { TableSelectCell } from "../../../06-molecules/TableSelectCell";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";

interface State {
    selectedRows: string[];
}

/**
 *
 */
interface StateProps {
    account: AccountRequest;
    loading: boolean;
}

/**
 *
 */
interface OwnProps {
    results: GeneralLedgers;
    onChange: <K extends keyof AccountRequest>(key: K, value: AccountRequest[K]) => void;
    generalLedgerNumber?: string;
}

/**
 *
 */
interface DispatchProps {
    loadResults: (skip: number) => void;
}

/**
 *
 */
type Props = OwnProps & StateProps & DispatchProps;

/**
 *
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    account: s.prop("accountRequest").map(e => ({
        ...e,
    })),
    loading:
            isRemoteLoading(s, RemoteScope.GENERAL_LEDGER)
    ,
});

/**
 *
 */
const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    loadResults: (skip: number) => dispatch(remoteTrigger(RemoteScope.GENERAL_LEDGER, {
        skip: skip,
    })),
});

/**
 *
 */
export class ResultsComp
    extends React.Component<Props, State> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props) {
        super(props);
        this.state = this.refreshedRowState();
        this.selectItem = this.selectItem.bind(this);
        this.refreshedRowState = this.refreshedRowState.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.amIChecked = this.amIChecked.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
    }

    /**
     *
     */
    public render() {
        return (
            <React.Fragment>
                <Table
                    hasActions
                    data={{
                        columns: this.resultsData().columns,
                        rows: this.resultsData().rows,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        sort: this.resultsData().sort,
                    }}
                />
                {(this.props.results && this.props.results.totalPages && this.props.results.totalPages > 1) ?
                    <Container
                        className="scl-h-text-align--center"
                        theme={{
                            padding: { "": { t: 3, b: 2 }, "sm": { t: 4, b: 3 } },
                        }}
                    >
                        <Pagination
                            pageCount={this.props.results.totalPages}
                            currentPage={this.props.results.number}
                            onPageChange={this.handlePageClick}
                            theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                        />
                    </Container> : null}
            </React.Fragment>
        );
    }

    private selectItem(value: boolean | undefined, name: string) {
        this.setState({
            selectedRows: !!value ? [
                name,
            ] : [],
        }, () => this.props.onChange("generalLedger", { id: Number(this.state.selectedRows[0]) }));
    }

    /**
     *
     */
    private refreshedRowState(): State {
        return {
            selectedRows: this.props.generalLedgerNumber ? [this.props.generalLedgerNumber] : [],
        };
    }

    private handlePageClick(skip: number) {
        this.props.loadResults(skip);
    }

    private amIChecked(name: string, selectedRows: string[]): boolean {
        return selectedRows.some((row) => row === name);
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results.content.map((row, _index) => {
            const checked = this.amIChecked(row.id.toString(), this.state.selectedRows);
            return ({
                id: row.id,
                data: [
                    (
                        <TableSelectCell
                            key={`table-cell-${row.id}`}
                            checked={checked}
                            selectItem={() => this.selectItem(!checked, row.id.toString())}
                        />
                    ),
                    row.name ?? "",
                    row.accountCode,
                ],
            });
        });
    }

    /**
     *
     */
    private resultsData() {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Select",
                },
                {
                    label: "Name",
                },
                {
                    label: "GL Account",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}

/**
 *
 */
export const Results = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResultsComp);
